import { render, staticRenderFns } from "./BadItems.vue?vue&type=template&id=a040bf20&scoped=true&"
import script from "./BadItems.vue?vue&type=script&lang=js&"
export * from "./BadItems.vue?vue&type=script&lang=js&"
import style0 from "./BadItems.vue?vue&type=style&index=0&id=a040bf20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a040bf20",
  null
  
)

export default component.exports